import React from "react";
import { truncateText } from "../../hooks/TextVeiw";
import { Link } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "../../icons";
import { useTranslation } from "react-i18next";
import { useStateContext } from "../../../context/ContextProvider";
const C_SmallBlog = ({ blog }) => {
  const { t } = useTranslation();
  const { currentLang } = useStateContext();
  const isAr = currentLang === "ar";
  const title = isAr ? blog.title_Ar : blog.title_En;

  return (
    <div className=" flex flex-row w-full gap-2  items-center justify-center p-2 h-42 overflow-hidden">
      <img src={blog.image} className="w-2/5  rounded-md " />
      <div className="flex flex-col gap-2 items-start w-3/5 h-full ">
        <p className="caption text-light-caption dark:text-dark-caption ">
          {blog.date}
        </p>
        <h6 className="teaxt-sm font-kufi text-light-subtitle dark:text-dark-subtitle">
          {truncateText(title, 4)}
        </h6>
        <Link
          to={`/BlogDetails_page/${blog.id}`}
          state={{ blogData: blog }}
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          <button
            className=" transition delay-150 duration-300 ease-in-out ltr:hover:translate-x-4 rtl:hover:-translate-x-4 hover:scale-110
          text-light-link dark:text-dark-link flex flex-row items-center text-sm font-kufi gap-2 "
          >
            <span> {t("Reade more")}</span>
            <span>
              {" "}
              {isAr ? (
                <IoIosArrowBack size={18} />
              ) : (
                <IoIosArrowForward size={18} />
              )}
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default C_SmallBlog;
